import Vue from "vue";
import { Image } from "element-ui";
let previewer: Image;
/**
 * 图片预览
 * @param options
 */
export function preview(options: {
  url: string;
  previewSrcList?: string[];
  zIndex?: number;
}) {
  console.log("url", options.url);
  const props = {
    src: options.url,
    previewSrcList: options.previewSrcList || [options.url],
    zIndex: options.zIndex,
  };
  if (previewer) {
    previewer.$destroy();
  }
  const comp = new (Vue.extend(Image))({
    propsData: props,
  }) as Image;
  comp.$mount();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (comp as any).showViewer = true;
  previewer = comp;
}
